import { Checkbox } from "@mui/material";
import { ColumnDef } from "@tanstack/react-table";
import i18n from "@lib/i18n";
import { DriverGroup } from "@lib/types/driver_group";
import ActionButton from "@components/ActionButton";
import { Eye, Pencil } from "lucide-react";

export const columns = (
  setItemToEdit: React.Dispatch<React.SetStateAction<DriverGroup | undefined>>,
  setEditDialogOpen: React.Dispatch<React.SetStateAction<boolean>>,
  viewItem: (driverGroup: DriverGroup) => void
): ColumnDef<DriverGroup>[] => [
  {
    id: "select",
    header: ({ table }) => (
      <Checkbox
        checked={table.getIsAllRowsSelected()}
        indeterminate={table.getIsSomeRowsSelected()}
        onChange={() => table.toggleAllRowsSelected()}
        aria-label="Select all"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onChange={() => row.toggleSelected()}
        aria-label="Select row"
      />
    ),
    enableSorting: false,
    enableHiding: false,
    meta: { hideOnSmallScreens: true },
  },
  {
    accessorKey: "name",
    header: i18n.t("table.name"),
    cell: ({ row }) => (
      <span className="text-neutral-600 leading-none font-book text-base">
        {row.original.name}
      </span>
    ),
    enableSorting: true,
  },

  {
    accessorKey: "description",
    header: i18n.t("table.description"),
    cell: ({ row }) => (
      <span className="text-neutral-600 leading-none font-book text-base">
        {row.original.description}
      </span>
    ),
    enableSorting: true,
    meta: { hideOnSmallScreens: true },
  },
  {
    id: "actions",
    header: i18n.t("table.actions"),
    enableHiding: false,
    cell: ({ row }) => {
      return (
        <div className="flex w-full items-center justify-center gap-1">
          <ActionButton
            title={i18n.t("general.view")}
            onClick={() => viewItem(row.original)}
          >
            <Eye size="20" />
          </ActionButton>

          <ActionButton
            title={i18n.t("general.edit")}
            onClick={() => {
              setItemToEdit(row.original);
              setEditDialogOpen(true);
            }}
          >
            <Pencil size="20" />
          </ActionButton>
        </div>
      );
    },
  },
];
